import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
const styles = require("./PhotoCard.module.scss");

const PhotoCard = (props) => {
  const { photo, name, jobTitle, theme, click } = props;

  return (
    <div className={styles.card} onClick={click}>
      <GatsbyImage image={photo} className={styles.photo} />
      <div className={`${styles.info} bkg-${theme}`}>
        <div className={styles.nameRow}>
          <h4>{name}</h4>
          <div className={styles.arrowWrap} />
        </div>
        <p>{jobTitle}</p>
      </div>
    </div>
  );
};

export default PhotoCard;
